/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlAuthenticator } from './ControlAuthenticator';
import {
    ControlAuthenticatorFromJSON,
    ControlAuthenticatorFromJSONTyped,
    ControlAuthenticatorToJSON,
} from './ControlAuthenticator';

/**
 * 
 * @export
 * @interface ControlGetEnrolledAuthenticatorsResponse
 */
export interface ControlGetEnrolledAuthenticatorsResponse {
    /**
     * 
     * @type {Array<ControlAuthenticator>}
     * @memberof ControlGetEnrolledAuthenticatorsResponse
     */
    authenticators: Array<ControlAuthenticator>;
}

/**
 * Check if a given object implements the ControlGetEnrolledAuthenticatorsResponse interface.
 */
export function instanceOfControlGetEnrolledAuthenticatorsResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "authenticators" in value;

    return isInstance;
}

export function ControlGetEnrolledAuthenticatorsResponseFromJSON(json: any): ControlGetEnrolledAuthenticatorsResponse {
    return ControlGetEnrolledAuthenticatorsResponseFromJSONTyped(json, false);
}

export function ControlGetEnrolledAuthenticatorsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlGetEnrolledAuthenticatorsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'authenticators': ((json['authenticators'] as Array<any>).map(ControlAuthenticatorFromJSON)),
    };
}

export function ControlGetEnrolledAuthenticatorsResponseToJSON(value?: ControlGetEnrolledAuthenticatorsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'authenticators': ((value.authenticators as Array<any>).map(ControlAuthenticatorToJSON)),
    };
}

